import { render } from "./PeoplePaperPractice.vue?vue&type=template&id=74335683&scoped=true"
import script from "./PeoplePaperPractice.vue?vue&type=script&lang=js"
export * from "./PeoplePaperPractice.vue?vue&type=script&lang=js"

import "./PeoplePaperPractice.vue?vue&type=style&index=0&id=74335683&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74335683"]])

export default __exports__